
(function documentDefinition() {
    'use strict';
    angular.module('Actions')
        .service('organizartionalUnitAction', [
             '$translate', 'adminOrganizationalUnitService', 'alerts', 'errorsExtend', '$q',
             function documentAction($translate, adminOrganizationalUnitService, alerts, errors, $q) {

                 this.enable = function enable(ou) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     $translate(['Warning', 'OUEnableConfirmText', 'Yes', 'No']).then(function (translated) {
                         return alerts.confirm(translated.Warning, translated.OUEnableConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                             if (!result) {
                                 defered.reject();
                                 return result;
                             }

                             return adminOrganizationalUnitService.enable(ou).then(function (doc) {
                                 errors.showSuccess('OUEnableInSucces');
                                 defered.resolve(doc);

                             }, function (error) {
                                 errors.showError(error);
                                 defered.reject();
                             });
                         });
                     });
                     return promise;
                 };


                 this.disable = function enable(ou) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     $translate(['Warning', 'OUDisableConfirmText', 'Yes', 'No']).then(function (translated) {
                         return alerts.confirm(translated.Warning, translated.OUDisableConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                             if (!result) {
                                 defered.reject();
                                 return result;
                             }

                             return adminOrganizationalUnitService.disable(ou).then(function (doc) {
                                 errors.showSuccess('OUDisableInSucces');
                                 defered.resolve(doc);

                             }, function (error) {
                                 errors.showError(error);
                                 defered.reject();
                             });
                         });
                     });
                     return promise;
                 };

             }
        ]);

})();